import React, { createContext, useContext, useState } from 'react';

export type WeatherRegionSetting = 'sg' | 'sg+jb';

const WEATHER_REGION_KEY = 'myCarParkedWhereWeatherRegion';

interface WeatherRegionContextType {
  region: WeatherRegionSetting;
  setRegion: (r: WeatherRegionSetting) => void;
}

const WeatherRegionContext = createContext<WeatherRegionContextType>({
  region: 'sg',
  setRegion: () => {},
});

export const WeatherRegionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [region, setRegionState] = useState<WeatherRegionSetting>(() => {
    const saved = localStorage.getItem(WEATHER_REGION_KEY);
    return (saved as WeatherRegionSetting) || 'sg';
  });

  const setRegion = (r: WeatherRegionSetting) => {
    setRegionState(r);
    localStorage.setItem(WEATHER_REGION_KEY, r);
  };

  return React.createElement(
    WeatherRegionContext.Provider,
    { value: { region, setRegion } },
    children
  );
};

export const useWeatherRegion = () => useContext(WeatherRegionContext);
